import { createSelector } from 'reselect';
import { RequestStatus } from '../Constants';
import { createHubUserEmailOptionsForSelect } from '../utils/hubUsers';
export const getHubUsers = state => state.hubUsers.get('hubUsers');
export const getHubUsersEmailOptionsForSelect = createSelector([getHubUsers], hubUsers => createHubUserEmailOptionsForSelect(hubUsers));
export const getShouldFetchHubUsers = state => [RequestStatus.UNINITIALIZED, RequestStatus.FAILED].includes(state.hubUsers.get('status'));